const actionTypes = {
  ADD_PROJECT_ACTION_ITEM: 'ADD_PROJECT_ACTION_ITEM',
  UPDATE_SUB_NAV: 'UPDATE_SUB_NAV',
};

export default actionTypes;
